/**
 * Responsible for using the creditcard behavior within a floating label.
 * @module elements/fields/iconifyCreditCard
 */
import $ from 'jquery';
import 'jquery-mask-plugin';

import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'ccMask';

export const DEFAULTS = {};


/**
 * Contains the list of regex associated with credicards
 * @type {Array}
 */
export const regExList = [
  { name: 'visa', regex: '^4' },
  { name: 'amex', regex: '^(34|37)' },
  { name: 'master', regex: '^5[1-5]' },
  { name: 'jcb', regex: '^(352[89]|35[3-8][0-9])' },
  { name: 'discover', regex: '^(6011|65|64[4-9]|622(1(2[6-9]|[3-9])|[2-8]{2}|9([01]|2[0-5])))' },
];

/**
 * Shows the active credit card icon
 * @param {HTMLFormElement} formField - The form element in the floating label
 * @param {HTMLElement} container - The icon container
 * @param {Object} iconNodes - icons keyed by icon name with icon HTML element
 */
const getCardIcon = (
    $el,
    defaultCCTemplate,
    amexCCTemplate,
    initRegExpList,
    maskOptions,
  ) => {
  const ccNum = $el.val();
  const [{ name: activeCard } = { name: 'generic' }] = initRegExpList.filter(({ regex }) => regex.test(ccNum));
  $el.mask(activeCard === 'amex' ? amexCCTemplate : defaultCCTemplate, maskOptions);
};
/**
 * Initialize credit cards' regex
 * @private
 * @returns {Array} - returns initialized regex array
 */
const initRegex = () => regExList.map(({ name, regex }) => ({
  name, regex: new RegExp(regex),
}));
/**
 * Set Data Attributes for each credit card icons
 * @private
 * @param {HTMLFormElement} formField - The form element in the floating label
 * @param {HTMLElement} container - The icon container
 * @param {Object} iconNodes - icons keyed by icon name with icon HTML element
 */
const applyMask = ($el) => {
  const defaultCCTemplate = '0000 0000 0000 0000';
  const amexCCTemplate = '0000 000000 00000';
  const initRegExpList = initRegex();
  const maskOptions = {
    onKeyPress: () => {
      getCardIcon(
        $el,
        defaultCCTemplate,
        amexCCTemplate,
        initRegExpList,
        maskOptions,
      );
    },
    'translation': { 0: {pattern: /[0-9*]/}}
  };
  getCardIcon(
    $el,
    defaultCCTemplate,
    amexCCTemplate,
    initRegExpList,
    maskOptions,
  );
  $el.mask(defaultCCTemplate, maskOptions);
};

const checkEncrypted = ($el) => {
  const isEncrypted = typeof $el.context !== 'undefined' && ($el.context.value).includes('*');

  if(!isEncrypted) {
    applyMask($el);
  }

  $el.on('input', function(){
    applyMask($el);
  });
};

/**
 * Initializes an ccMask based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * ccMask
 * @param {Object} options - Options used for wiring up the ccMask
 * @see DEFAULTS
 */
export default function ccMask(el) {
  const $el = $(el);
  checkEncrypted($el);
}

// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, ccMask);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/cc-mask.js